export default {"src":"/_next/static/media/entertaining.b2ed1188.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};